import styles from './Image.scss';
/* eslint-disable react/prop-types */ // TODO: add props

export const Image = ({ blockData }) => {
  const {
    file: { url },
    caption,
  } = blockData;

  return <img className={styles.image} src={url} alt={caption} />;
};
